(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-lead-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.srLeadFormReady) return;
    window.srLeadFormReady = true;

    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
    try {
      const params = new URLSearchParams(window.location.search);
      const found = {};
      UTM_KEYS.forEach((key) => {
        if (params.get(key)) found[key] = params.get(key).slice(0, 120);
      });
      if (Object.keys(found).length) sessionStorage.setItem('sr_utm', JSON.stringify(found));
    } catch (e) {}

    if (customElements.get('sr-lead-form')) return;

    customElements.define(
      'sr-lead-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.openedAt = 0;
          if (!this.form) return;
          // Inline forms are never "opened": start the bot timer on first interaction.
          this.addEventListener('focusin', () => {
            if (!this.openedAt) this.openedAt = Date.now();
          });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
          this.form.addEventListener('input', (event) => this.clearError(event.target));
          this.form.addEventListener('change', (event) => this.clearError(event.target));
        }

        onOpen() {
          if (!this.openedAt) this.openedAt = Date.now();
          const success = this.querySelector('[data-step="success"]');
          if (success && !success.hidden) return;
          const first = this.form && this.form.querySelector('input[name="first_name"]');
          if (first && window.matchMedia('(min-width: 750px)').matches) first.focus();
        }

        normalizePhone(raw) {
          let value = String(raw || '').replace(/[\s().\-\/]/g, '');
          if (value.startsWith('00')) value = '+' + value.slice(2);
          if (!value.startsWith('+')) value = '+39' + value.replace(/^0039/, '');
          const digits = value.replace(/\D/g, '');
          if (!/^\+\d+$/.test(value) || digits.length < 9 || digits.length > 15) return null;
          return value;
        }

        setError(name, show) {
          const field = this.form.elements[name];
          const message = this.form.querySelector(`[data-error-for="${name}"]`);
          if (field && field.setAttribute) field.setAttribute('aria-invalid', show ? 'true' : 'false');
          if (message) message.classList.toggle('is-visible', show);
        }

        clearError(target) {
          if (!target || !target.name) return;
          this.setError(target.name, false);
        }

        validate() {
          const f = this.form.elements;
          const checks = {
            first_name: f.first_name.value.trim().length > 0,
            phone: this.normalizePhone(f.phone.value) !== null,
            email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim()),
            privacy: f.privacy.checked,
          };
          let firstInvalid = null;
          Object.entries(checks).forEach(([name, ok]) => {
            this.setError(name, !ok);
            if (!ok && !firstInvalid) firstInvalid = f[name];
          });
          if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
          return !firstInvalid;
        }

        buildSource() {
          let source = this.dataset.source || 'Sito';
          try {
            const utm = JSON.parse(sessionStorage.getItem('sr_utm') || '{}');
            const bits = [utm.utm_source, utm.utm_campaign].filter(Boolean);
            if (bits.length) source += ' | ' + bits.join(' / ');
            else if (utm.fbclid) source += ' | facebook';
            else if (utm.gclid) source += ' | google ads';
          } catch (e) {}
          return source.slice(0, 250);
        }

        showSuccess(firstName) {
          const formStep = this.querySelector('[data-step="form"]');
          const success = this.querySelector('[data-step="success"]');
          const title = success.querySelector('[data-success-title]');
          if (title) {
            const template = title.dataset.template || '';
            title.textContent = template.replace('[nome]', firstName).replace(/\s+,/, ',').replace(/\s{2,}/g, ' ').trim();
          }
          formStep.hidden = true;
          success.hidden = false;
          success.focus();
        }

        async onSubmit(event) {
          event.preventDefault();
          if (this.busy) return;
          const errorBox = this.form.querySelector('[data-form-error]');
          errorBox.hidden = true;
          if (!this.validate()) return;

          const f = this.form.elements;
          const firstName = f.first_name.value.trim();

          // Bots: honeypot filled or submitted within 2s of opening. Pretend success, send nothing.
          if (f.website.value || (this.openedAt && Date.now() - this.openedAt < 2000)) {
            this.showSuccess(firstName);
            return;
          }

          const payload = new URLSearchParams({
            first_name: firstName,
            last_name: f.last_name.value.trim(),
            email: f.email.value.trim().toLowerCase(),
            phone: this.normalizePhone(f.phone.value),
            contact_pref: (this.form.querySelector('input[name="contact_pref"]:checked') || {}).value || 'chiamata',
            message: f.message ? f.message.value.trim() : '',
            marketing: f.marketing && f.marketing.checked ? '1' : '0',
            privacy: '1',
            product: this.dataset.product || '',
            source: this.buildSource(),
            page_url: window.location.href.split('#')[0].slice(0, 500),
            website: '',
            submitted_at: new Date().toISOString(),
          });

          this.busy = true;
          this.classList.add('is-busy');
          try {
            const response = await fetch(this.dataset.endpoint, { method: 'POST', body: payload });
            if (!response.ok) throw new Error('HTTP ' + response.status);
            this.showSuccess(firstName);
            const detail = { product: payload.get('product'), contact_pref: payload.get('contact_pref') };
            document.dispatchEvent(new CustomEvent('sr:lead-submitted', { detail }));
            try {
              if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
                Shopify.analytics.publish('sr_lead_submitted', detail);
              }
            } catch (e) {}
          } catch (error) {
            errorBox.hidden = false;
          } finally {
            this.busy = false;
            this.classList.remove('is-busy');
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
